import { useTranslation } from "react-i18next";
import { Option } from "ui";

import { useGetOrdersLocations } from "../apis";

const useOrdersFilter = () => {
  const { t } = useTranslation();
  const { locations, isLoading: isLocationsLoading } = useGetOrdersLocations();
  const allLocations: Option[] = [
    { value: "", label: t("All") },
    ...locations.map((location) => ({
      value: location.id,
      label: `${location.neighborhood}, ${location.city}, ${location.country}`
    }))
  ];

  return {
    drivers: [],
    isDriversLoading: false,
    locations: allLocations,
    isLocationsLoading
  };
};

export default useOrdersFilter;
